// Port of api/fuel/app/classes/filter/search/games/rules/query/languages.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'languages',
	isIndex: function() { return 'language' }
})
